<template>
    <div class="wrapper">
        <!-- Image -->
        <div v-for='(m, index) in media' @click.stop='viewEnlargedOrOpenRelations(m, index)'>
            <img :src="m.thumbnail_path"
                v-show='index == show'
                :class="{'zoom-cursor': !m.is_folder, 'clickable': m.is_folder}"
                class='image'
                :title='m.title'>
        </div>

        <!-- Index Navigation -->
        <div class='index' v-show='hasManyMedia'>
            <span>{{show + 1}} / {{media.length}}</span>
        </div>

    </div>
</template>

<script>
    import EventHub from './eventHub.js'
    import ViewRelated from '../mixins/viewRelated.js'
    import MediaParser from '../mixins/mediaParser.js'
    import ManageRelations from '../mixins/manageRelations.js'
    import Media from '../mixins/Media.js'

    export default {
        props: ['object', 'trick', 'width', 'height'],
        mixins: [MediaParser, ViewRelated, ManageRelations],
        created: function () {
            var self = this

            // Sigh...In some cases we may need to change the index remotely
            EventHub.$on('change-index', function (param) {
                if (self.object._id == param.id) {
                    self.show = param.index
                }
            })

            // When the component is first mounted fetch search data
            this.$nextTick(function () {
                self.media = self.parseMedia(self.object, self.width, self.height)
                self.media = self.addFolderImage(self.object, self.media, self.width, self.height)
                self.media = self.addNoImage(self.object, self.media, self.width, self.height)

                if (self.media.length < 2) {
                    self.hasManyMedia = false
                }
            })
        },
        beforeDestroy: function () {
            EventHub.$off('change-index')
        },
        data: function () {
            return {
                show: 0,
                hasManyMedia: true,
                media: [],

            }
        },
        methods: {
            loopIndex: function (index) {
                if (index < 0 || index >= this.media.length) {
                    return
                }

                this.show = index
            },
            viewEnlargedOrOpenRelations: function (media, index) {
                // If no image return
                if (!media.is_folder && this.object.images.length == 0 && this.object.media.length == 0){
                    return
                }

                // If folder then click will open closest relation
                if (media.is_folder) {
                    var indices = this.closestChildIndex(this.object)

                    if (indices) {
                        this.viewRelated({'indices': indices, 'parent-keyword': this.object._id}, true)
                    } else {
                        this.viewRelated({'parent-keyword': this.object._id}, true)
                    }
                    return
                }

                // If in grid view open summary
                var non_viewable = _.filter(this.media, {non_viewable: true})
                var selected = index - non_viewable.length
                EventHub.$emit('view-enlarged', {object: this.object, selected: selected})
            }
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../sass/variables.scss';

    .wrapper {
        font-size: 0;
        text-align: center;
        position: relative;

        .image {
            display: inline-block;
            vertical-align: middle;
            max-height: 100%;
            max-width: 100%;
        }

        .trick {
            display: inline-block;
            vertical-align: middle;
        }
    }

    .index {
        padding: 3px;
        font-size: 7pt;
    }
</style>
